import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { buildRecruitTarget } from '../../lib/recruitParams';

/**
 * Redirect an old recruiting URL onto its equivalent Recruit tab, carrying any
 * other query params through.
 *
 * A plain <Navigate to="/recruit?mode=schools&tab=matches"> would silently drop
 * them, and /matches?peek=<unitid> is a real review affordance MatchesPanel
 * still reads — losing it would break links that exist today.
 *
 * Params already on the incoming URL win over the defaults, so an explicit
 * ?tab= is respected rather than overwritten.
 */
export default function RecruitRedirect({ tab }) {
  const [searchParams] = useSearchParams();
  return <Navigate to={buildRecruitTarget(tab, searchParams)} replace />;
}
